import { delay } from './promiseUtils';

export async function retryOnError(func, options = {}) {
  const { maxRetry = 100, scale = 1, maxTimeIntervalInMS = 30000 } = options;
  const toMsScaler = 100 * scale;

  let numRetry = 0;
  let waitingFactor = 2;
  let result;

  const wait = async (error) => {
    const timeToWaitInMS = waitingFactor * toMsScaler;
    console.warn(`Retry ${numRetry} failed with error ${error}, waiting ${timeToWaitInMS} ms ...`);
    await delay(timeToWaitInMS);

    const nexTimeToWait = waitingFactor * 2;
    const nexTimeToWaitInMS = nexTimeToWait * toMsScaler;

    if (nexTimeToWaitInMS >= maxTimeIntervalInMS) {
      waitingFactor = maxTimeIntervalInMS / toMsScaler;
    } else {
      waitingFactor = nexTimeToWait;
    }
  };
  const retryLoop = async () => {
    try {
      numRetry += 1;
      result = await func();
      console.log(`Successfull retry after ${numRetry} attempts.`);
    } catch (retryError) {
      if (numRetry >= maxRetry) {
        console.error('Max retry, stoping', retryError);
        throw new Error(`Max retry reached (${maxRetry}) with error: 'error ${numRetry}'`);
      }
      await wait(retryError);
      await retryLoop();
    }
  };
  await retryLoop();
  return result;
}
